module.exports = __webpack_public_path__ + "media/images/social-share-button/douban-59306a4ec1a7595eda35e925b1772296.svg";